import { settings as raySettings } from '@wework/ray-core';

export const NUMBER_OF_RESULTS = 1;
export const MAX_BUILDINGS_TO_RETURN = 6;
export const MIN_BUILDINGS_TO_RETURN = 3;
export const BUILDINGS_NEAR_ME_EXPERIMENT = 'buildings_near_me';
export const nearbyBuildingsSectionContainerId = 'home-nearby-buildings__container';
export const nearbyBuildingsSlider = '#nearby-buildings-slider';
export const nearbyBuildingsSliderOptions = {
  perView: 3,
  bound: true,
  breakpoints: {
    [raySettings.breakpointsInPixels.tablet]: {
      perView: 1,
      peek: 73.75,
      gap: 16
    },
    [raySettings.breakpointsInPixels.desktop]: {
      gap: 24,
      perView: 2
    }
  }
};
